// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../configurator-css/" + "PhotoSphere" + ".css";
};